import olms from 'ol-mapbox-style';
import 'ol/ol.css';

olms('map', 'data/osm-restyle.json');
